/**
 * Creates a concurrency-limited queue for async tasks.
 * At most `limit` tasks run simultaneously; the rest wait in queue.
 */
export function createConcurrencyQueue(limit: number) {
  let active = 0;
  const queue: (() => void)[] = [];

  return function enqueue(fn: () => Promise<void>): void {
    const run = () => {
      active++;
      void fn().finally(() => {
        active--;
        if (queue.length > 0) {
          queue.shift()!();
        }
      });
    };
    if (active < limit) {
      run();
    } else {
      queue.push(run);
    }
  };
}
